var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6502 16.5124C20.616 12.714 23.7611 10.8661 23.905 10.7801C22.1237 8.18381 19.3629 7.82908 18.3927 7.80079C16.074 7.55684 13.8248 9.18791 12.6436 9.18791C11.4388 9.18791 9.61987 7.82436 7.65948 7.86443C5.13678 7.90333 2.77676 9.36351 1.4824 11.631C-1.18883 16.2543 0.803396 23.0485 3.36264 26.7856C4.64285 28.617 6.13879 30.6594 8.09683 30.5875C10.0124 30.5097 10.728 29.3677 13.0397 29.3677C15.3301 29.3677 16.0021 30.5875 17.999 30.5415C20.0549 30.5097 21.3492 28.703 22.5847 26.8563C24.0641 24.7597 24.6582 22.6926 24.6818 22.5865C24.6347 22.57 20.6903 21.0639 20.6502 16.5124ZM16.8779 5.3424C17.9082 4.05428 18.6132 2.30182 18.4175 0.523438C16.9263 0.589435 15.0614 1.55464 13.9874 2.81448C13.0373 3.92464 12.1885 5.74428 12.4078 7.45549C14.0829 7.58041 15.8028 6.61049 16.8779 5.3424Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.4660b03263c4f150f9df6cee10e59923.svg";
export { ForwardRef as ReactComponent };